<i nz-icon [nzType]="icon" [nzTheme]="iconTheme"></i>
<span>{{ label | translate }}</span>